import { TestIdClassNameProps } from "@app/types/Common";
import BrightcoveVideoPlayer from "@src/app/components/Player/BrightcoveVideoPlayer";
import { Field } from "@src/app/types/Cue";
import { Name } from "@src/app/types/enums";
import { BT_BRIGHTCOVE_ACCOUNT_ID } from "@src/app/util/constant";
import { getFieldValue } from "@src/app/util/helpers";

export type BrightcoveVideoProps = TestIdClassNameProps & {
  fields: Field[];
  annotation: string;
};

export function BrightcoveVideo({
  testId,
  rootClassName,
  fields,
  annotation,
}: BrightcoveVideoProps): React.ReactElement {
  const id = getFieldValue(fields, Name.BrightcoveId);

  return (
    <>
      {typeof id == "string" ? (
        <div
          className={rootClassName}
          data-testid={testId}
          data-annotation={annotation}
        >
          <BrightcoveVideoPlayer
            videoId={id}
            accountId={BT_BRIGHTCOVE_ACCOUNT_ID}
          />
        </div>
      ) : null}
    </>
  );
}
